module.exports = __webpack_public_path__ + "static/media/vector3.77f6aa2a.svg";